<article class="country-card__container">
    <header class="country-card__header-container">
        <div class="country-card__header">
            <img class="country-card__image" [src]="country.icono" [alt]="country.nombre">
            <div class="country-card__info">
                <h2 class="country-card__title">{{ country.nombre }}</h2>
                <p class="country-card__population">Población: {{ country.poblacion | number }}</p>
            </div>
        </div>

        <button class="country-card__favorite-btn" (click)="toggleFavorite()" [disabled]="isLoading"
            [class.disabled]="isLoading">
            <i class="country-card__icon" [class.fas]="country.isFavorite" [class.fa-heart]="true"
                [class.far]="!country.isFavorite" [class.country-card__icon--filled]="country.isFavorite"></i>
        </button>
    </header>
    <p class="country-card__description">
        <span class="country-card__description--bold">
            Costo Vida Idiomas 6 Meses:
        </span>
        {{ country.costoMatriculaIdioma ? (country.costoMatriculaIdioma  | number) : 'N/A' }} 
        {{country.costoMatriculaIdioma ? country.moneda : ''}}
    </p>
    <p class="country-card__description">
        <span class="country-card__description--bold">
            Costo Educación Pública Promedio:
        </span>
        {{ country.costoEducacionPublica.min| number }} {{country.moneda}} - {{ country.costoEducacionPublica.max |
        number }} {{country.moneda}}
    </p>
    <p class="country-card__description">
        <span class="country-card__description--bold">Costo Educación Privada Promedio: </span>
        {{ country.costoEducacionPrivada.min| number
        }} {{country.moneda}} - {{ country.costoEducacionPrivada.max | number }} {{country.moneda}}
    </p>
    <p class="country-card__description">
        <span class="country-card__description--bold">Costo de Vida Estudiantil Promedio: </span>
        {{ country.costoVidaMensual.min | number }}
        {{country.moneda}} - {{ country.costoVidaMensual.max | number }} {{country.moneda}}
    </p>

    <footer class="country-card__footer">
        <app-button (onClick)="openDetailDialog()">Ver más detalles</app-button>
    </footer>
</article>
